/*
 * @Author: your name
 * @Date: 2020-05-20 17:03:19
 * @LastEditTime: 2020-05-21 17:25:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mapbox-gl-js\src\mbtiles_vector\mbtiles_vector_worker.js
 */ 
import pako from 'pako';
import Protobuf from 'pbf';
import VectorTileWorkerSource from '../source/vector_tile_worker_source';
import vt from '@mapbox/vector-tile';

function loadVectorData(params, callback) {
    let imgdata =  convertBase64ToUint8Array(params.base64Data)
    // let pakodata = pako.inflate(imgdata)
    var rawData = params.base64Data ? imgdata : undefined;
    const vectorTile = new vt.VectorTile(new Protobuf(rawData));
    let resp = {}
    resp.rawData = rawData;
    resp.cacheControl = null;
    resp.expires = null;
    resp.vectorTile = vectorTile
    callback(undefined, resp);
}

function convertBase64ToUint8Array(base64) {
    var raw = self.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }

    return array;
}

class MBTilesVectoeWorkerSource extends VectorTileWorkerSource {

    constructor(actor, layerIndex, availableImages) {
        super(actor, layerIndex, availableImages, loadVectorData);
    }
};

export default  MBTilesVectoeWorkerSource
